<template>
  <div class="dashboard">
    <el-card>
      <div slot="header">
        <span>欢迎使用奥特莱斯管理系统</span>
      </div>
      <div class="welcome-content">
        <p>请从左侧菜单选择功能模块</p>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Dashboard'
}
</script>

<style scoped>
.welcome-content {
  text-align: center;
  padding: 50px 0;
}

.welcome-content p {
  font-size: 18px;
  color: #666;
}
</style>
